import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Shipment } from '../models/shipment.model';
import { ShipmentsService } from "../services/shipments.service"
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs/Observable';
import { ClientsService } from '../services/clients.service';
import { server } from '../services/constants'

@Component({
  selector: 'app-active-shipments',
  templateUrl: './active-shipments.component.html',
  styleUrls: ['./active-shipments.component.css']
})
export class ActiveShipmentsComponent implements OnInit {
  shipments: Shipment;
  bol;
  user;
  userShort;
  client;
  httpAddress = server;

  isLoggedIn$: Observable<boolean>;

  constructor(private shipmentsService: ShipmentsService,
              private router: Router,
              private authService: AuthService,
              private clientsService: ClientsService ) {
    this.authService.getUserClientPromise2()
    .then(() => {
      this.authService.user$.subscribe((user:any) => {
        this.user = user;
        this.userShort = user.firstname + user.lastname.slice(0, 1);
        console.log(this.userShort)
        this.isLoggedIn$ = this.authService.isLoggedIn$;
    });
   });
   }

  ngOnInit() {this.onStartup() };

  onStartup() {
    this.isLoggedIn$ = this.authService.isLoggedIn$
    this.authService.user$.subscribe((user:any) => {
      console.log(user)
      this.user = user;
      if(!user.message) {
        if( user.clientid == 0) {
          this.getShipments(user.clientid);
          this.authService.client$.subscribe((client) => {
            console.log(client)
            this.client = client;
          });
        }else {
          this.authService.client$.subscribe((client) => {
            console.log(client)
            this.client = client;
            if (client.cname != 'No Client Selected' && user.clientid != 0){
              this. getShipments(client.clientid);
              }
            })
        }
      }
    })
  }

  getShipments(clientid){
  if(clientid > 0 ) {
    this.shipmentsService.getShipments(clientid)
    .then(shipmentsNoPod => {
      this.shipments = shipmentsNoPod;

    })
  }else if(localStorage.getItem('selectedId') && this.user.clientid == 0){
    const clientIdStored = localStorage.getItem('selectedId');
    this.shipmentsService.getShipments(clientIdStored)
    .then(shipmentsNoPod => {
      this.shipments = shipmentsNoPod;
    });
  }else{
    this.shipmentsService.getShipments(clientid)
    .then(shipmentsNoPod => {
      this.shipments = shipmentsNoPod;
    });
  }

  }

  onBolSearch(){
    this.router.navigate(['/editbol/' + this.bol])
  }

  onSetClient(clientid) {
    // get client info when a client is selected
    this.clientsService.getSelectedClient(clientid)
    .then(response => {
      if(!response.message) {
        const clientarray = response;
        this.client = clientarray[0]
      } else {
        console.log(response.message)
        // TODO  create authservice logic for 403 repsone to set user BASE_USER
      }
    });
}
addToBoard(bolqtid) {
  console.log('Clicked add to board ' + bolqtid)
  // code to add to board or cancel if exists
  this.shipmentsService.addToBoard (bolqtid, this.userShort, this.user.userid)
  .then( (result: any) => {
    // check result here
    console.log(result)
    if (result.result === 'exists') {
      const answer = confirm('already exists Want to Update?');
      if (answer === true) {
        // now update the entry
        console.log('choose update')
        this.shipmentsService.updateBoard (bolqtid, this.userShort, this.user.userid)

      }
    }else {
      alert(result.result);
    }
  });

}

checkSelectedClient() { // TODO
  if (localStorage.getItem('selectedId')){
    // if clientid stored rettriev it and use
    const clientid = localStorage.getItem('selectedId');
  }
}

convertDate(date) {
  const dataArray = date.split('-');
  const convDate = dataArray[0] + '/' + dataArray[1] + '/' + dataArray[2];
  return convDate;

}
}



// WEBPACK FOOTER //
// ./src/app/active-shipments/active-shipments.component.ts